import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Layout from "../layouts";
import Callout from "../components/callout";
import Header from "../components/header";
import GalleryImage from "../components/gallery-image";
import iconTripleThreat from "../images/icons/triple-threat.svg";
import iconTrustUs from "../images/icons/trust-us.svg";
import iconCertificate from "../images/icons/certificates.svg";
import iconNicheManufacturing from "../images/icons/niche-manufacturing.svg";
import iconReputableClient from "../images/icons/reputable-clients.svg";
import iconInnovative from "../images/icons/innovative.svg";
import iconTurnKey from "../images/icons/turn-key.svg";
import iconCustomPackaging from "../images/icons/cutom-packaging.svg";
import Contact from "../components/contact";
var _default = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(_default, _React$Component);
    function _default() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = _default.prototype;
    _proto.findImage = function findImage(imageName) {
        var _this$props$data$unsp, _this$props$data$unsp2;
        return (_this$props$data$unsp = this.props.data.unsplash.edges.find(function (e) {
            return e.node.name === imageName;
        })) === null || _this$props$data$unsp === void 0 ? void 0 : (_this$props$data$unsp2 = _this$props$data$unsp.node.childImageSharp) === null || _this$props$data$unsp2 === void 0 ? void 0 : _this$props$data$unsp2.fluid;
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(Layout, {
            className: "page page--index"
        }, /*#__PURE__*/ React.createElement(Header, {
            title: "American Softgels Inc.",
            message: "Here at American Softgels, we are a privately owned softgel contract manufacturer with 30+ years of experience in encapsulation. We specialize in providing our clients and brands of all sizes a transparent, trustworthy, turn-key manufacturing solution.",
            image: this.findImage("home-main")
        }), /*#__PURE__*/ React.createElement("div", {
            className: "grid mtb-2"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Why Trust Us?",
            message: "One of the most crucial decisions you\u2019ll make as a brand is choosing a trustworthy, regulations-compliant contract manufacturer that fits your specific needs. Not only that, but manufacturing softgels is a complicated and unique process, vastly different than manufacturing capsules or tablets. Because of this, there are very few reliable softgel manufactures domestically causing long lead times, high MOQs and less innovation. Those are the problems we resolve on a daily basis!",
            icon: iconTrustUs,
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("certifications")
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Certifications",
            message: "We are FDA registered operating out of our cGMP certified facility in Loyalhanna, PA. We hold third-party GMP certification through NSF and are an approved foreign manufacturer by Health Canada. These internationally recognized, third-party GMP inspections and certifications help assure our customers that the products we manufacture are up to the standards they demand in ensuring their purity, potency, and quality.",
            icon: iconCertificate,
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Niche Manufacturing Process",
            message: "Manufacturing softgels is an extremely niche process comparatively speaking to other delivery methods of cannabinoids in the space. To put this into context, there are hundreds, if not thousands of gummy and/or tincture manufacturers in the US alone. Guess how many softgel manufacturers?... Less than 20.",
            icon: iconNicheManufacturing,
            titlePosition: "center"
        }), /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("niche-manufacturing")
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("2-blending")
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Triple Threat",
            message: "We provide our customers with fair market pricing (based on ingredients and volume), low MOQs (50k softgels per sku), and short lead times (2-4 weeks).",
            icon: iconTripleThreat,
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Innovative Formulation Capabilities",
            message: "Our formulating team have both studied and instructed their craft all over the world and have a background in Pharmacognosy, organic chemistry and botanical medicine. This allows us to offer our clients the ability to develop custom softgel formulations that wouldn\u2019t otherwise be possible!",
            icon: iconInnovative,
            titlePosition: "center"
        }), /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("innovative-nano-technologies")
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("2-inspection")
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Equipment And Quality",
            message: "Quality is constantly monitored during every step of the manufacturing process to achieve the highest level of technical excellence in softgel production. Another crucial differentiator is the quality of our machinery. Our encapsulation machines are proven, reputable, Japanese made to ensure the tightest tolerances possible.",
            icon: iconTurnKey,
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Custom Packaging",
            message: "Need help with custom labels, boxes, or other various print/marketing materials? Our packaging partner works directly with our sales team and clients to provide industry leading packaging options that will bring your brand to life!",
            icon: iconCustomPackaging,
            titlePosition: "center"
        }), /*#__PURE__*/ React.createElement(GalleryImage, {
            image: this.findImage("high-quality-turn-key")
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid mtb-4 mmtb-2"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Reputable, Industry Leading, Repeat Clients",
            message: "We work with some of the top private/white label distributors and retailers in the space that ship our products to clients world-wide.",
            icon: iconReputableClient,
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement(Contact, null));
    };
    return _default;
}(React.Component);
export { _default as default };
var query = "3418090361";
